<div *ngIf="ledger">
  <div class="form-group">
    <label>Created At</label>
    <input type="text" class="form-control" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" name="created_at" [(ngModel)]="ledger.created_at" />
  </div>
  <div class="form-group">
    <label>Chart of Account</label>
    <select class="form-control" [(ngModel)]="ledger.chart_of_account_id" (change)="chartOfAccountChange()">
      <option *ngFor="let chartOfAccount of formOptions.chart_of_accounts" [value]="chartOfAccount.value">{{ chartOfAccount.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>Type</label>
    <select class="form-control" [(ngModel)]="ledger.category">
      <option value="credit">Credit</option>
      <option value="debit">Debit</option>
    </select>
  </div>
  <div class="form-group">
    <label>Amount</label>
    <input type="number" class="form-control" size="10" [(ngModel)]="ledger.amount" />
  </div>
  <div class="form-group">
    <label>Description</label>
    <textarea class="form-control" [(ngModel)]="ledger.description"></textarea>
  </div>
</div>
